module.exports = __webpack_public_path__ + "img/Cumulative impact assessment-Mitigation measures.354c15af.svg";